// 对应字段聚合提示
const AGGREGATION_RULES: {[keyName: string]: string} = {
  /* 落地页 */
  'Mobile_Active-Users_Appannie': 'AVG',
  'Mobile_Active-Users_SensorTower': 'AVG',
  'Mobile_Revenue_Appannie': 'SUM',
  'Mobile_Revenue_SensorTower': 'SUM',
  'Mobile_Downloads_Appannie': 'SUM',
  'Mobile_Downloads_SensorTower': 'SUM',
  'Mobile_RPD_Appannie': 'SUM', // 被扩充
  'Mobile_Cumulative-Revenue_Appannie': 'SUM',
  'Mobile_Cumulative-Revenue($)_Appannie': 'SUM',
  'Mobile_Cumulative-Downloads_Appannie': 'SUM',
  'PC_PCU_Steam': 'MAX',
  'PC_ACU_Steam': 'AVG', // 被扩充
  // 'PC_Avg-Players-Per-Hour_Steam': 'AVG', // 还没上
  'PC_MAU_Newzoo': 'AVG',
  'PC_Acquisitions%_Newzoo': 'WEIGHTED AVG', // 被扩充
  'PC_Player-Share_Newzoo': 'WEIGHTED AVG',
  'PC_Lifetime-Players_Newzoo': 'MAX',
  'PC_Physical-Revenue_NPD': 'SUM',
  'PC_Digital-Revenue_MScience': 'SUM',
  'PC_Digital-Units_MScience': 'SUM',
  'PC_Digital-ARPPU_MScience': 'AVG',
  'PC_Digital-AST_MScience': 'AVG', // 被扩充
  'Console_MAU_Newzoo': 'AVG',
  'Console_Acquisitions%_Newzoo': 'AVG', // 被扩充
  'Console_Lifetime-Players_Newzoo': 'MAX',
  'Console_Physical-Revenue_NPD': 'SUM',
  'Console_Digital-Revenue_MScience': 'SUM',
  'Console_Digital-Units_MScience': 'SUM',
  'Console_Digital-ARPPU_MScience': 'AVG',
  'Console_Digital-AST_MScience': 'AVG', // 被扩充
  'Streaming_Hours-Watched_Stream-Hatchet': 'SUM',
  'Streaming_Airtime_Stream-Hatchet': 'SUM',
  'Streaming_Peak-CCV_Stream-Hatchet': 'MAX', // 被扩充加上info内容
  'Streaming_Avg-CCV_Stream-Hatchet': 'AVG',
  'Companies_Mobile-Revenue_Appannie': 'SUM',
  'Companies_Revenue_Appannie': 'SUM',
  'Companies_PC-Revenue_Appannie': 'SUM',
  'Companies_Console-Revenue_Appannie': 'SUM',
  'Companies_Downloads_Appannie': 'SUM',

  /* OverView卡片 */
  'Mobile_Hours-Watched_Stream-Hatchet': 'SUM',
  'Mobile_Peak-CCV_Stream-Hatchet': 'MAX', // 被扩充加上info内容
  'Mobile_Downloads_DataBrain': 'SUM',
  'Mobile_Active-Users_DataBrain': 'AVG',
  'Mobile_Revenue_DataBrain': 'SUM',
  'Mobile_Retention-D2_':'AVG',
  'Mobile_Retention-D2_Appannie':'AVG',
  'PC_Hours-Watched_Stream-Hatchet': 'SUM',
  'PC_Peak-CCV_Stream-Hatchet': 'MAX', // 被扩充加上info内容
  'Console_Hours-Watched_Stream-Hatchet': 'SUM',
  'Console_Peak-CCV_Stream-Hatchet': 'MAX', // 被扩充加上info内容

  /* Stats页 */
  'Mobile_Avg-DAU_DataBrain': 'AVG',
  'Mobile_Avg-DAU_Appannie': 'AVG',
  'Mobile_Avg-DAU_SensorTower': 'AVG',
  'Mobile_Avg-WAU_DataBrain': 'AVG',
  'Mobile_Avg-WAU_Appannie': 'AVG',
  'Mobile_Avg-WAU_SensorTower': 'AVG',
  'Mobile_Avg-MAU_DataBrain': 'AVG',
  'Mobile_Avg-MAU_Appannie': 'AVG',
  'Mobile_Avg-MAU_SensorTower': 'AVG',
  'Mobile_Sum-Revenue_DataBrain': 'SUM',
  'Mobile_Avg-Revenue_DataBrain': 'AVG',
  'Mobile_Sum-Revenue_Appannie': 'SUM',
  'Mobile_Avg-Revenue_Appannie': 'AVG',
  'Mobile_Sum-Revenue_SensorTower': 'SUM',
  'Mobile_Avg-Revenue_SensorTower': 'AVG',
  'Mobile_Sum-DataBrain-Downloads_DataBrain': 'SUM',
  'Mobile_Avg-DataBrain-Downloads_DataBrain': 'AVG',
  'Mobile_Sum-Downloads_DataBrain': 'SUM',
  'Mobile_Avg-Downloads_DataBrain': 'AVG',
  'Mobile_Sum-DataBrain-Downloads_Appannie': 'SUM',
  'Mobile_Avg-DataBrain-Downloads_Appannie': 'AVG',
  'Mobile_Sum-Downloads_Appannie': 'SUM',
  'Mobile_Avg-Downloads_Appannie': 'AVG',
  'Mobile_Sum-DataBrain-Downloads_SensorTower': 'SUM',
  'Mobile_Avg-DataBrain-Downloads_SensorTower': 'AVG',
  'Mobile_Sum-Downloads_SensorTower': 'SUM',
  'Mobile_Avg-Downloads_SensorTower': 'AVG',
  'Mobile_Airtime_Stream-Hatchet': 'SUM',
  'Mobile_Avg-CCV_Stream-Hatchet': 'AVG',
  'PC_Airtime_Stream-Hatchet': 'SUM',
  'PC_Avg-CCV_Stream-Hatchet': 'AVG',
  'Console_Airtime_Stream-Hatchet': 'SUM',
  'Console_Avg-CCV_Stream-Hatchet': 'AVG',
  'Console_Player-Share_Newzoo': 'WEIGHTED AVG',

    //   retention
    'Mobile_D2_Appannie': 'AVG',
    'Mobile_D7_Appannie': 'AVG',
    'Mobile_D15_Appannie': 'AVG',
    'Mobile_D3_Appannie': 'AVG',
    'Mobile_D31_Appannie': 'AVG',
};

// 对应的游戏类型
const AMEND_TYPE: {[keyName: string]: string} = {
  /* 落地页 */
  mobile: 'Mobile',
  pc: 'PC',
  console: 'Console',
  streaming: 'Streaming',
  company: 'Companies',
}

// 对应的指标
const AMEND_METRIC: {[keyName: string]: string} = {
  /* 落地页 */
  DAU: 'Active Users',
  WAU: 'Active Users',
  MAU: 'Active Users',
  'Revenue($)': 'Revenue',
  Downloads: 'Downloads',
  PCU: 'PCU',
  'Avg. Players': 'ACU',
  'Digital Revenue($)': 'Digital Revenue',
  Units: 'Digital Units',
  'Digital ARPPU($)': 'Digital ARPPU',
  'AST($)': 'Digital AST',
  'Physical Revenue($)': 'Physical Revenue',
  'Acquisition%': 'Acquisitions%',
  ACU: 'ACU',
  'Lifetime Players': 'Lifetime Players',
  'Lifetime player': 'Lifetime Players',
  'Hours Watched': 'Hours Watched',
  'Peak CCV': 'Peak CCV',
  'Avg CCV': 'Avg CCV',
  Airtime: 'Airtime',
  'Mobile Revenue($)': 'Mobile Revenue',
  'PC Revenue($)': 'PC Revenue',
  'Console Revenue($)': 'Console Revenue',
  
  /* OverView卡片 */
  'Lifetime Player': 'Lifetime Players',
  'Retention D2': 'Retention D2',

  /* Stats */
  'Acquistion%': 'Acquisitions%',
}

// 对应的平台
const AMEND_PLATFORM: {[keyName: string]: string} = {
  /* 落地页 */
  appannie: 'Appannie',
  sensortower: 'SensorTower',
  steamcharts: 'Steam',
  Mscience: 'MScience',
  npd: 'NPD',
  newzoo: 'Newzoo',
  hatchet: 'Stream Hatchet',

  /* OverView卡片 */
  steam: 'Steam',
  stream: 'Stream Hatchet',
  mscience: 'MScience',
  pnd: 'NPD',
  ogdb: 'DataBrain',

  /* Stats页 */
  databrain: 'DataBrain',
  PCU: 'Steam',
  ACU: 'Steam',
  'Physical Revenue($)': 'NPD',
  MAU: 'Newzoo',
  'Acquistion%': 'Newzoo',
  'Player Share': 'Newzoo',
}

// Ranking数据源
const RNKING_DATA_SOURCE: string[] = ['appstore', 'googleplay', 'epic', 'steam', 'xbox', 'nintendo', 'playstation'];

// 修改成正确的Ranking指标名称
const RNKING_METRIC: {[keyNmae: string]: string} = {
  'Free': 'Top Free',
  'New Free': 'Top New Free',
  'Paid': 'Top Paid',
  'New Paid': 'Top New Paid',
  'Grossing': 'Top Grossing',
  'New and Trending': 'New Trending',
  'New And Trending': 'New Trending',
  'Xbox Upcoming': 'Upcoming',
  'Xbox Most Played': 'Most Played',
  'P.Heat': 'Predicted Heat',
  'Best selling': 'Best Selling',
  'New release': 'New Release',
  'Most played': 'Most Played',
  'Best sellers': 'Best Sellers',
  'Coming soon': 'Coming Soon',
  'Most downloaded': 'Most Downloaded',
  'New games': 'New Games',
  'Indies games': 'Indies Games',
  'Free to play': 'Free to Play',
  'Free To Play': 'Free to Play',
  'Top Wish List': 'Top Wish Lists',
};

export {
  AGGREGATION_RULES,
  AMEND_TYPE,
  AMEND_METRIC,
  AMEND_PLATFORM,
  RNKING_DATA_SOURCE,
  RNKING_METRIC,
};
